// Doubleclick logic for table rows
document.addEventListener('dblclick', function (event) {
    const target = event.target.closest('.dbl-clickable');

    if (target === null || !target.classList.contains('dbl-clickable')) {
        return;
    }

    const windowTarget = target.dataset.target;
    const url = target.dataset.dblclick;
    const method = target.dataset.method;

    if(url === undefined) {
        return;
    }

    if (method === 'POST') {
        $.ajax({
            type: "POST",
            url: url,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                if (location.href.includes('/offerPosition/addArticle/')) {
                    Swal.fire({
                        text: "Artikel wurde erfolgreich hinzugefügt.",
                        icon: "success",
                        showConfirmButton: false,
                        toast: true
                    }).then(window.location.href = data.redirect);
                } else {
                    window.location.href = data.redirect;
                }
            }
        });
    } else {
        if(windowTarget === undefined)
        {
            window.location.href = url;
        }
        else
        {
            window.open(url, windowTarget);
        }
    }
})
